import { Avatar } from "@/components/ui";
import type { PublicPage } from "@/lib/api/types";
import { accentStyle } from "@/lib/accent";
import { HELPER_SUBLINE, thankYouLine } from "@/lib/copy";

/** Page name with an initial avatar in the business accent, then thanks before the ask. */
export function ReviewHeader({
  page,
  embedded = false,
}: {
  page: Pick<PublicPage, "name" | "accent" | "subject_noun">;
  embedded?: boolean;
}) {
  const NameTag = embedded ? "p" : "h1";
  return (
    <header className="flex items-start gap-4">
      <Avatar
        name={page.name}
        initials={1}
        size="large"
        shape="rounded"
        className="tv-accent"
        style={{ ...accentStyle(page.accent), boxShadow: "none" }}
      />
      <div className="min-w-0 flex-1">
        <NameTag className="wds-heading-1 text-label-strong">{page.name}</NameTag>
        <p className="mt-1 text-label-neutral">
          {thankYouLine(page.subject_noun)} {HELPER_SUBLINE}
        </p>
      </div>
    </header>
  );
}
